import React from 'react';
import { soundToPlay } from '../../mechanics/sounds/sound';
import { sceneSlice } from '../../store/reducers/SceneReducer';
import { useAppDispatch } from '../../store/store';
import BaseButton from '../ui/BaseButton';
import './Camp.scss';
import CampContent from './CampContent';


const Camp = () => {
    const dispatch = useAppDispatch()
    const { setScene } = sceneSlice.actions

    const backClick = () => {
        dispatch(setScene("main"))
    }

    return (
        <div className='camp component'>
            <div className="camp__wrapper">
                <h1 className="camp__title component-title">Camp</h1>
                <CampContent />
                <BaseButton name='Back' onClick={backClick} />
            </div>
        </div>
    );
};

export default Camp;